import { Injectable } from '@angular/core';
import { HeadersRequest } from '../util/model/header-request.inteface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { MetadataResponse } from '../../service/model/response/metadataResponse.model';
import { ApiService } from '../util/api.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private _apiService: ApiService) {}

  public getUserMetadata(token: string): Observable<HttpResponse<MetadataResponse>> {
    const headers = this.getHeaders(token);
    return this._apiService.get(`${environment.basePathAccount}/user-accounts/me/metadata`, null, headers);
  }

  private getHeaders(auth: string): Array<HeadersRequest> {
    return [{ param: 'Authorization', value: 'Bearer ' + auth }];
  }
}
